export const IndexDBService = Symbol('IndexDBService');

export interface IndexDBService<T> {
    saveData(key: string, value: T): Promise<void>;
    getData(key: string): Promise<T>;
    clearData(key: string): Promise<void>;
}
